import React from 'react';
import { FairPriceChart } from '../../../chart/fair-price-chart';
import { FairPriceResultCard } from '../../../result-card/fair-price-result-card';

interface FairPriceTabPeResultsProps {
    fairPrice: number;
    currentPrice: number;
    upsideDownside: number;
    currency: string;
}

export const FairPriceTabPeResults: React.FC<FairPriceTabPeResultsProps> = ({
    fairPrice,
    currentPrice,
    upsideDownside,
    currency,
}) => (
    <FairPriceResultCard
        fairPrice={fairPrice}
        currentPrice={currentPrice}
        upsideDownside={upsideDownside}
        currency={currency}
    >
        <FairPriceChart />
    </FairPriceResultCard>
);
